import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  FormHelperText,
} from "@chakra-ui/react";
const LastName = ({ options, formik }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const hasError = formik.touched.lastName && formik.errors.lastName;
  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="lastName" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <Input
        size="sm"
        id="lastName"
        name="lastName"
        type="text"
        placeholder={options.placeholder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.lastName}
      />
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.lastName}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default LastName;
